import insertRecipientsShownAtFront from './insertRecipientsShownAtFront';
import AtMentionsViewState from '../store/schema/AtMentionsViewState';
import getAndPopulateSuggestedContacts from 'owa-recipient-cache/lib/actions/getAndPopulateSuggestedContacts';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import setIsSearching from './setIsSearching';
import { action } from 'satcheljs/lib/legacy';

export default action('setSuggestedContacts')(function setSuggestedContacts(
    viewState: AtMentionsViewState,
    currentWellContents?: ReadWriteRecipientViewState[]
) {
    getAndPopulateSuggestedContacts(viewState.recipientsShown);
    if (currentWellContents) {
        insertRecipientsShownAtFront(viewState.recipientsShown, currentWellContents, 5);
    }
    setIsSearching(viewState, false /* isSearching */);
});
